import { ICreateMediaItem } from "@interfaces/createMediaItem";
import { IFormValues } from "@interfaces/Shared/formValues";

export const getFilesForUpload = (formValues: IFormValues) => {
  if (typeof formValues.gallery !== "string") {
    if (formValues.gallery) {
      return Array.from(formValues.gallery as ICreateMediaItem[]).map(
        (item: any) => ({
          field: "gallery",
          file: item,
          name: item.name,
        })
      );
    }

    return Object.keys(formValues)
      .filter(
        (key) => key.includes("Url") && formValues[key] instanceof FileList
      )
      .flatMap((key) =>
        Array.from(formValues[key] as FileList).map((file) => ({
          field: key,
          file: file,
          name: file.name,
        }))
      );
  }

  return [];
};
